const PayIndex = () => import('../pages/Payment/index')
const PayDetail = () => import('../pages/Payment/PayDetail')
const PaySuccess = () => import('../pages/Payment/PaySuccess')

export default [{
	path: '/pay',
	component: PayIndex,
	meta: {
		requiresAuth: true
	},
	children: [{
		name: 'payDetail',
		path: '/pay/:codeUrl/:orderAmount/:orderNo/:time/:source',
		component: PayDetail,
		props: true
	},
	{
		name: 'paySuccess',
		path: '/paySuccess/:orderId/:price/:quantity/:name/:source',
		component: PaySuccess
	}
	]
}]
